import { Card } from "../../../components/Card";
import { GoalCard } from "./GoalCard";
import { LockWithTooltip } from "./LockWithTooltip";
import { GOAL_STATE } from "../utils/constant";

type Goal = {
    id: string;
    title: string;
    state: string;
    current_progress: number;
    target_progress: number;
};

export function BadgeCenterFieldPro1({ isLocked, goalsLevel }: { isLocked: boolean, goalsLevel: any }) {
    const goals: Goal[] = goalsLevel?.goals ?? [];
    const subTierLabel = goalsLevel?.current_level_name;

    return (
        <Card className="!p-[18px] h-[350px] flex flex-col">
            <div className="flex flex-col mb-2">
                <div className="flex items-center gap-1.5">
                    {isLocked ? <LockWithTooltip /> : <></>}
                    <span className="text-base font-semibold text-black">Goals to <span className="text-[#1E40AF]">{subTierLabel ?? "--"}</span></span>
                </div>
            </div>
            {goals.length > 0 ? (
                <div className="flex flex-col gap-2 flex-1 overflow-y-auto">
                    {goals.map((goal) => (
                        <GoalCard
                            key={goal.id}
                            title={goal.title}
                            value={goal.current_progress}
                            totalValue={goal.target_progress}
                            type="field-pro1"
                            isCompleted={goal.state === GOAL_STATE.COMPLETED}
                            countText={`${goal.current_progress}/${goal.target_progress}`}
                        />
                    ))}
                </div>
            ) : (
                <div className="flex flex-1 items-center justify-center">
                    <span className="text-sm text-black">Currently no goals available</span>
                </div>
            )}
        </Card>
    )
}
